module.exports = __webpack_public_path__ + "media/images/flags/4x3/mus-24a9735238dfff01d3613a18b1858690.svg";